import { Component, OnInit, ViewEncapsulation } from '@angular/core'
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import {Location} from '@angular/common';


@Component({
  selector: 'travelpay-features',
  templateUrl: './travelpay-features.component.html',
  styleUrls: ['./travelpay-features.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TravelPayFeaturesComponent implements OnInit {
  public showLoader: boolean = false;
 
  public menuItems = [
    {
      'icon': 'travelpayfeatures1.png',
      'title': 'Zero Cross Currency Fees',
      'url': '',
    },
    {
        'icon': 'travelpayfeatures2.png',
        'title': 'Reload Card Anytime / Anywhere',
        'url': '',
      },
    {
      'icon': 'travelpayfeatures3.png',
      'title': 'Tap & Pay',
      'url': '',
    },
    {
      'icon': 'travelpayfeatures4.png',
      'title': 'App Enabled Card Management',
      'url': '',
    },
    {
      'icon': 'travelpayfeatures5.png',
      'title': 'Chip & Pin - Based Card',
      'url': '',
    },
   
    {
      'icon': 'travelpayfeatures6.png',
      'title': 'Real Time Transaction alerts',
      'url': '',
    },
    {
      'icon': 'travelpayfeatures8.png',
      'title': 'Card Insurance Coverage upto 5Lac',
      'url': '',
    },
    {
      'icon': 'travelpayfeatures9.png',
      'title': '3D Secure Authentication',
      'url': '',
    },
    {
        'icon': 'travelpayfeatures10.png',
        'title': 'Not Linked To Your Bank Account',
        'url': '',
      },
      {
        'icon': 'travelpayfeatures11.png',
        'title': 'Surcharge Free withdrawals at AllPoint ATMs',
        'url': '',
      },
     
    
  ];
 

  constructor(
    public router: Router,
    public toast: ToastrService,
    private _location: Location
   
  ) { }

  ngOnInit() {
    this.getProfileList();
  }

 
  getProfileList() {
   
  }

 

  proceedToNextPage(pageUrl) {
    this.router.navigate([pageUrl]);
  }

  goToBackPage() {
    this._location.back();
  }

  
}
